import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from "react-router";
import {searchActions, searchSelectors} from "../../store/search";
import Loading from '../../components/Base/Loading'
import Layout from '../../components/Layout'
import Search from '../../pages/Search'
import {schoolSelectors} from "../../store/school";
import {chatActions} from "../../store/chat";

/* Container for New Posts page */

class SearchContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			width: 0,
			height: 0,
			students: [],
			searchTerm: ''
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		//this.setState({loading: true});
		// // let searchTerm = ''
		// try {
		//   const {location} = this.props;
		//   if(location.state && location.state.search){
		//     searchTerm = location.state.search
		//   }
		// } catch (e) {
		//   console.log(e)
		// }
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
		this.getStudentListener();
	}

	// componentDidUpdate(prevProps, prevState, snapshot) {
	// 	const {updateStudents} = this.props;
	// 	const {students} = this.state;
	// 	if (students !== prevState.students) {
	// 		updateStudents(students)

	// 	}
	// }

	getStudentListener = () => {
		 this.props.firebase.students().orderBy('last_name', 'asc').onSnapshot((snapshot) => {
			let result = [];
			snapshot.forEach(doc => (result.push({ id: doc.id, ...doc.data() })));
			this.props.updateStudents(result);
			// for(let i in result){
			// 	if(!result[i].sub_dorm){
			// 		this.updateStudentDorms(result[i])
			//
			// 	}
			// }
			// this.updateStudentDorms(result[0])
			//this.setState({students: result, loading: false})
		}
		);
	}


	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		//this.listener()
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	render() {
		// const {} = this.state;
		const {profile, isFaculty, loadingSchool, students, school} = this.props;

		// const [searchState, updateSearch] = useState(searchTerm);
		if(profile !== null && !isFaculty){
			return <Redirect to={'/app/home'}/>
		}

		return (
			<Layout {...this.props} noSideBar>
				{profile === null || loadingSchool === true ? <Loading/>:
					<Search {...this.props} width={this.state.width} students={students} school={school}/>}
			</Layout>
		);
	}
} 

const mapStateToProps = state => {
	return {
		loadingSchool: schoolSelectors.isLoading(state.school),
		schoolInfo: schoolSelectors.refreshSchool(state.school),
		search: searchSelectors.refreshSearch(state.search),
		filters: searchSelectors.refreshFilters(state.search),
		//rosterFilter: searchSelectors.getCheckinRosterFilter(state.search),
		students: searchSelectors.refreshCurrentResults(state.search),
		loading: searchSelectors.isLoading(state.search),
		rosterFilter: searchSelectors.getRosterFilter(state.search),
		allStudents: searchSelectors.refreshStudents(state.search)
	}
};

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	updateFilter: (filters) => {
		dispatch(searchActions.updateFilter(filters))
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	clearFilter: () => {
		dispatch(searchActions.clearFilter());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updateCurrentChat: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);
